import { filterCalls } from 'src/plugins/helpers/functions'
import { matchesDefaults } from 'src/plugins/helpers/wallboard-default-filters'

export default {
  getAgents: (state, getters, rootState) => {
    return rootState.users
      .filter(agent => {
        // only valid agents
        if (agent.is_destination || agent.read_only_access || !agent.enabled || !agent.active) {
          return false
        }

        // agent name filter
        if (state.filters.agent && !agent.name.toUpperCase().includes(state.filters.agent.toUpperCase())) {
          return false
        }

        // status filter
        if (state.filters.agentStatus !== 'all' && agent.agent_status !== state.filters.agentStatus) {
          return false
        }

        // ring group filter: agent is in any selected ring group, directly or through one of its teams
        if (state.filters.ringGroupIds.length) {
          const isInAnyRingGroup = state.filters.ringGroupIds.some((ringGroupId) => {
            const ringGroup = rootState.ringGroups?.find((rg) => rg.id === ringGroupId)
            const isAgentInRingGroupTeam = (ringGroup?.teams ?? [])
              .some((team) => team.users?.some((teamUser) => teamUser.id === agent.id))

            return isAgentInRingGroupTeam || agent.ring_group_ids.includes(ringGroupId)
          })

          if (!isInAnyRingGroup) {
            return false
          }
        }

        // team filter: agent is in any selected team
        if (state.filters.teamIds.length) {
          const teams = rootState?.teams?.filter(team => state.filters.teamIds.includes(team.id)) ?? []
          if (!teams.some(team => team.users.includes(agent.id))) {
            return false
          }
        }

        return true
      })
  },

  getCallsEnabledColumns: (state) => {
    return state.callsEnabledColumns
  },

  getFilters: (state) => {
    return state.filters
  },

  getDefaultFilters: (state, getters, rootState) => {
    return rootState.auth.profile?.setting_wallboard_default_filters || null
  },

  isUsingDefaultFilters: (state, getters) => {
    return matchesDefaults(state.filters, getters.getDefaultFilters)
  },

  getLiveCalls: (state, getters, rootState) => {
    return filterCalls(state.calls.live, state, rootState)
  },

  getParkedCalls: (state, getters, rootState) => {
    return filterCalls(state.calls.parked, state, rootState)
  },

  getQueuedCalls: (state, getters, rootState) => {
    return filterCalls(state.calls.queued, state, rootState)
  },

  getSummary: (state) => {
    return state.summary
  },

  getViewMode: (state) => {
    return state.viewMode
  }
}
